module.exports = __webpack_public_path__ + "img/success.22ba817c.svg";